<template>
  <label class="p-form-label">
    <slot></slot>
    <span v-if="$slots.label" class="p-form-label__label">
      <slot name="label"></slot></span
    ><IconRequired v-if="required" />
    <span v-if="$slots.addition" class="p-form-label__addition">
      <slot name="addition"></slot>
    </span>
  </label>
</template>

<script lang="ts">
import IconRequired from "@/common/components/icons/IconRequired.vue";
import { Options, Vue } from 'vue-class-component';

@Options({
  props: {
	required: { type: Boolean, required: false, default: false }
  },
  components: {
    IconRequired
  }
})
export default class FormLabel extends Vue {
  required!: boolean;
}
</script>

<style lang="scss" scoped>
.p-form-label {
  line-height: 1.5;
  font-weight: bold;
  margin-bottom: rem(8);
  margin-right: 0.5em;
  display: block;

  @include sp {
    font-size: rem(14);
  }

  &__addition {
    color: $common-black-sub;
    font-size: rem(10);
    font-weight: normal;
    line-height: (14/10);
    margin-top: rem(2);
    margin-bottom: rem(2);
    display: inline-block;
  }
}
</style>
